import axios from "@/util/axios";
import {PaymentMethodsResponse} from "@/interfaces/httpResponses/PaymentMethodsResponse";
import {PaymentMethod} from "@/interfaces/entities/PaymentMethod";
import {Price} from "@/interfaces/entities/Price";
import {VuexActionContext} from "@/store/index";
import {SubmitPaymentResponse} from "@/interfaces/httpResponses/SubmitPaymentResponse";
import {SubmitPaymentRequest} from "@/interfaces/httpRequests/SubmitPaymentRequest";
import {GetPurchaseHistoryResponse} from "@/interfaces/httpResponses/GetPurchaseHistoryResponse";
import {PurchaseHistoryEntry} from "@/interfaces/entities/PurchaseHistoryEntry";
import {AddCreditcardResponse} from "@/interfaces/httpResponses/AddCreditcardResponse";
import {SubmitCreditPaymentRequest} from "@/interfaces/httpRequests/SubmitCreditPaymentRequest";
import {PaymentDetails} from "@/interfaces/entities/PaymentDetails";
import {PaymentDetailsResponse} from "@/interfaces/httpResponses/PaymentDetailsResponse";
import {PaymentDetailsRequest} from "@/interfaces/httpRequests/PaymentDetailsRequest";
import {GetCurrenciesResponse} from "@/interfaces/httpResponses/GetCurrenciesResponse";
import { Currency } from "@/interfaces/entities/Currency";
import { ChangeCurrencyResponse } from "@/interfaces/httpResponses/ChangeCurrencyResponse";
import { ChangeCurrencyRequest } from "@/interfaces/httpRequests/ChangeCurrencyRequest";
import { UserCreditHistoryRequest } from "@/interfaces/httpRequests/UserCreditHistoryRequest";
import { UserCreditHistoryResponse } from "@/interfaces/httpResponses/UserCreditHistoryResponse";

export interface PaymentsState {
}

export const paymentsState: PaymentsState = {};

export const paymentsMutations = {};

export const paymentsActions = {

    async FETCH_PAYMENT_METHODS(context: VuexActionContext<Array<Price>>, expectedPrices: Array<Price>): Promise<Array<PaymentMethod>> {
        const response: PaymentMethodsResponse = await axios.post("/payments/retrieve-methods", {
            expectedPrices
        });
        console.log("[PaymentsStore] Got Payment methods: ", response.data);
        return response.data;
    },

    async SUBMIT_PAYMENT(
        context: VuexActionContext<SubmitPaymentRequest>,
        requestBody: SubmitCreditPaymentRequest
    ): Promise<SubmitPaymentResponse> {
        const response: SubmitPaymentResponse = await axios.post(
            "/payments/credit/submit",
            requestBody
        );
        console.log("[PaymentsStore] Submit payment response: ", response.data);
        return response;
    },

    async FETCH_PAYMENT_DETAILS(context: VuexActionContext<PaymentDetailsRequest>, request: PaymentDetailsRequest): Promise<PaymentDetails> {
        const response: PaymentDetailsResponse = await axios.post("/payments/details", request);
        console.log("[PaymentsStore] Got Payment details: ", response.data);
        return response.data;
    },

    async FETCH_PURCHASE_HISTORY(): Promise<Array<PurchaseHistoryEntry>> {
        const response: GetPurchaseHistoryResponse = await axios.get("/payments/history?page_size=9999");
        console.log("[PaymentsStore] Got purchase history: ", response.data);
        return response.data.items;
    },

    async ADD_CREDIT_CARD(): Promise<string> {
        const response: AddCreditcardResponse = await axios.post("/users/current/payment-method");
        return response.data.paymentUrl;
    },

    async DELETE_CREDIT_CARD(): Promise<void> {
        await axios.delete("/users/current/payment-method");
    },

    async FETCH_CREDIT_CARD_INFOS() {
        const response: AddCreditcardResponse = await axios.get("/users/current/payment-method");
        return response.data;
    },

    async FETCH_CURRENCIES(): Promise<Array<Currency>> {
        const response: GetCurrenciesResponse = await axios.get("/payments/currencies");
        console.log("[PaymentsStore] Got currencies: ", response.data);
        return response.data;
    },

    async CHANGE_CURRENCY(context: VuexActionContext<ChangeCurrencyRequest>, request: ChangeCurrencyRequest): Promise<Currency> {
        const response: ChangeCurrencyResponse = await axios.post("/payments/currencies", request);
        console.log("[PaymentsStore] Changed currency: ", response.data);
        return response.data;
    },

    async FETCH_USER_CREDIT_HISTORY(context: VuexActionContext<UserCreditHistoryRequest>, request: UserCreditHistoryRequest): Promise<UserCreditHistoryResponse> {
        const response: UserCreditHistoryResponse = await axios.post("/users/current/credit/history", request);
        console.log("[PaymentsStore] Got user credit history: ", response.data);
        return response;
    },

    async DOWNLOAD_USER_CREDIT_HISTORY_CSV(context: VuexActionContext<void>, params: { from?: string; to?: string }): Promise<void> {
        const queryParams: string[] = [];
        if (params.from) {
            queryParams.push(`from=${encodeURIComponent(params.from)}`);
        }
        if (params.to) {
            queryParams.push(`to=${encodeURIComponent(params.to)}`);
        }
        
        const url = `/users/current/credit/history/csv${queryParams.length > 0 ? "?" + queryParams.join("&") : ""}`;
        const response = await axios.get(url, {
            responseType: "blob"
        });

        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });

        let filename = "transaction-history.csv";
        const disposition = response.headers["content-disposition"];
        if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
                filename = match[1];
            }
        }

        // Create a temporary link and trigger download
        const urlObject = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlObject;
        link.setAttribute("download", filename);

        link.click();
        link.remove();

        window.URL.revokeObjectURL(urlObject);
    }
};
